import { createFileRoute } from '@tanstack/react-router';

import { AccountMobilePage } from '@/pages/account/account-mobile-page';
import { AccountSettingsPage } from '@/pages/account/account-settings-page';
import { useMobile } from '@/shared/lib/use-mobile';

function MeRoute() {
  const isMobile = useMobile();
  return isMobile ? <AccountMobilePage /> : <AccountSettingsPage />;
}

export const Route = createFileRoute('/me')({ component: MeRoute });
